import { render } from "./DeptFooter.vue?vue&type=template&id=78a2f6db"
import script from "./DeptFooter.vue?vue&type=script&lang=js"
export * from "./DeptFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__